import { render, staticRenderFns } from "./Qti3Player.vue?vue&type=template&id=52171422"
import script from "./Qti3Player.vue?vue&type=script&lang=js"
export * from "./Qti3Player.vue?vue&type=script&lang=js"
import style0 from "./Qti3Player.vue?vue&type=style&index=0&id=52171422&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports